@import '../ui-cms-contact-channels';

ui-cms-contact-channels-email {
  display: block;

  @include channel_contactbox();
}
